module.exports = __webpack_public_path__ + "img/store_list_banner.b0cb4347.png";